import React, { useState, useEffect } from "react";
import "./ContainApproach.css";
import case1 from "../containassets/approach1.png";
import case2 from "../containassets/approach2.png";
import case3 from "../containassets/approach3.png";
import case4 from "../containassets/approach4.png";

export default function ContainApproach() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(3);
    
  const cases = [
    {
      img: case1,
      name: "Assessment & Planning",
      text: "Analyze applications and infrastructure readiness",
    },
    {
      img: case2,
      name: "Container Design",
      text: "Define container architecture and standards",
    },
    {
      img: case3,
      name: "Build & Automation",
      text: "Create container images and automate workflows",
    },
     {
      img: case4,
      name: "Deployment & Optimization",
      text: "Deploy, monitor, and optimize container environments",
    },
  ];

  const maxSlides = Math.max(0, cases.length - cardsToShow);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setCardsToShow(3);
      } else if (window.innerWidth >= 576) {
        setCardsToShow(2);
      } else {
        setCardsToShow(1);
      }
      setCurrentSlide(0);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDotClick = (index) => {
    if (index <= maxSlides) {
      setCurrentSlide(index);
    }
  };

  return (
    <div id="contain-approach" className="outsourcemainclass">
      <h2 className="heading">
        Why Choose BastionEx?
      </h2>
      <p className="subheading">
      Delivering Secure, Compliant, and High-Performance CI Solutions
      </p>

      <div className="cards">
        {cases.map((item, index) => (
          <div className="card" key={index}>
            <img src={item.img} alt="error" />
            <span>{item.name}</span>
            <p className="text">{item.text}</p>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{
              transform: `translateX(calc(-${(100 / cardsToShow) * currentSlide}% - ${currentSlide * 12}px))`,
            }}
          >
            {cases.map((item, index) => (
              <div
                className="card"
                key={index}
                style={{
                  flex: `0 0 calc(${100 / cardsToShow}% - ${
                    ((cardsToShow - 1) * 12) / cardsToShow
                  }px)`,
                }}
              >
                <img src={item.img} alt="error" />
                <span>{item.name}</span>
                <p className="text">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {maxSlides > 0 && (
          <div className="carousel-dots">
            {Array.from({ length: maxSlides + 1 }).map((_, index) => (
              <button
                key={index}
                className={`dot ${currentSlide === index ? "active" : ""}`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}